import { client } from 'lib/evi-api-gateway';

const url = `${process.env.REACT_APP_API_URL_RESOURCE}/api/user_log`;
const resourceUrl = `${process.env.REACT_APP_API_URL_RESOURCE}/api/resource_log`;
const analysisUrl = `${process.env.REACT_APP_API_URL_RESOURCE}/api/user/user_course_analysis`;

export async function getUserReport({ class_id, res_id, course_id, vote_id }: any) {
  return client.post({
    url: `${resourceUrl}/get_user_report`,
    form: {
      class_id,
      res_id,
      course_id,
      vote_id
    }
  });
}
export async function sendNotification({ class_id, res_id, course_id, user_ids }: any) {
  return client.post({
    url: `${resourceUrl}/send_notification`,
    form: {
      course_id,
      res_id,
      class_id,
      user_ids
    }
  });
}
export async function getStudentReport(class_id = null, course_id = null) {
  return client.post({
    url: `${url}/get_student_report`,
    form: {
      class_id,
      course_id
    }
  });
}
export async function getAnalysisByUser({ course_id, user_id }: any) {
  return client.post({
    url: `${analysisUrl}/get_analysis_by_user`,
    form: {
      course_id,
      user_id
    }
  });
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getUserReport,
  sendNotification,
  getStudentReport
};
